import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  clubsAction,
  getClubById,
} from "src/store/Slices/Administrator/ClubsSlice";
import AdminTable from "../Helpers/AdminTable";
import TableTitle from "../Helpers/TableTitle";
import { useState, useMemo } from "react";
import AddEditClubModal from "./Modals/AddEditClubModal";
import SureModal from "src/components/Modals/SureModal";
import dayjs from "dayjs";
import AntdMobileTable from "src/components/AntdMobileTable/AntdMobileTable";
import NumberChangesShowModal from "./Modals/NumberChangesShowModal";

const Clubs = ({ mnemo }) => {
  const dispatch = useDispatch();
  const searchInput = useRef(null);

  const items = [
    {
      key: "1",
      label: "Редактировать",
      onClick: () => {
        setIsOpenAddEditModal({ open: true, flag: "edit" });
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "updateBtn"),
    },
    {
      key: "2",
      label: "Удалить",
      onClick: () => {
        setIsOpenDeleteModal(true);
      },
      disabled: !mnemo?.children?.find((el) => el.mnemo === "deleteBtn"),
    },
    {
      key: "3",
      label: "Показать доп. номера",
      onClick: () => {
        setIsOpenAddEditModal({ open: true, flag: "contacts" });
      },
    },
    {
      key: "4",
      label: "Изменения телефона",
      onClick: () => {
        setIsOpenNumbersModal(true);
      },
    },
  ];

  const filterOptionsArr = [
    { label: "Фильрация", value: 0, index: undefined },
    { label: "По номеру", value: 1, index: "id", title: "Клуб" },
    {
      label: "По наименованию",
      value: 2,
      index: "name",
      title: "Наименование",
    },
    { label: "По адресу", value: 3, index: "address", title: "Адрес" },
    {
      label: "По телефону",
      value: 4,
      index: "phone",
      title: "Номер телефона",
    },
    { label: "По типу", value: 5, index: "typeName", title: "Тип" },
    {
      label: "По часам",
      value: 6,
      index: "workHours",
      title: "Часы работы",
    },
    {
      label: "По дате открытия",
      value: 7,
      index: "dateOpen",
      title: "Дата открытия",
    },
    {
      label: "По координатам",
      value: 8,
      index: "coordinates",
      title: "Координаты",
    },
  ];

  const [isDeleted, setIsDeleted] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [clubInfo, setClubInfo] = useState();
  const [isOpenAddEditModal, setIsOpenAddEditModal] = useState({
    open: false,
    flag: "",
  });
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const [isOpenNumbersModal, setIsOpenNumbersModal] = useState(false);

  // STORE
  const clubsList = useSelector((state) => state.ClubsSlice.clubsList);
  const clubsListLoading = useSelector(
    (state) => state.ClubsSlice.clubsListLoading
  );
  const globalCurrentClub = useSelector(
    (state) => state.ClubsSlice.currentClub
  );
  const onClickDelete = () => {
    dispatch(clubsAction({ flag: "delete", value: { id: clubInfo?.id } })).then(
      () => {
        dispatch(clubsAction({ flag: "get" }));
        setIsOpenDeleteModal(false);
      }
    );
    setPage(1);
    setPageSize(20);
  };
  const searchItemsMap = (keys, values) => {
    const formattedItems = {};
    if (keys && values) {
      keys.forEach((key, index) => {
        if (values[index] && values[index][0]) {
          if (key === "id") {
            formattedItems["idFrom"] = values[index][0];
            formattedItems["idTo"] = values[index][1];
          } else if (key === "typeName") {
            formattedItems["typeId"] = values[index][0];
          } else {
            formattedItems[key] = values[index][0];
          }
        }
      });
      return formattedItems;
    }
  };

  const clickOnAction = (element) => {
    setClubInfo(element);
    dispatch(getClubById(element.id));
  };

  const handlePaginationChange = (page, pageSize) => {
    dispatch(
      clubsAction({
        flag: "get",
        value: {
          count: pageSize,
          offset: pageSize * (page - 1),
        },
      })
    );
    setPage(page);
    setPageSize(pageSize);
  };

  const onClickSearchItem = (selectedKeys, dataIndex) => {
    setPage(1);
    setPageSize(20);
    dispatch(
      clubsAction({
        flag: "get",
        value: {
          isDeleted: isDeleted,
          [`${dataIndex}`]: selectedKeys[0],
        },
      })
    );
  };

  const handleTableChange = (pagination, filters, sorter) => {
    const payload = searchItemsMap(
      Object.keys(filters),
      Object.values(filters)
    );
    dispatch(
      clubsAction({
        flag: "get",
        value: {
          isDeleted: isDeleted,
          count: pagination.pageSize,
          offset: pagination.pageSize * (pagination.current - 1),
          orderBy: sorter?.column?.dataIndex,
          isDesc: sorter.order
            ? sorter.order === "ascend"
              ? true
              : false
            : undefined,
          ...payload,
        },
      })
    );
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  useEffect(() => {
    dispatch(clubsAction({ flag: "get" }));
  }, []);

  const showDeletedItems = (value) => {
    setIsDeleted(value);
    dispatch(clubsAction({ flag: "get", value: { isDeleted: value } }));
    setPage(1);
    setPageSize(20);
  };

  const formatedClubsRows = useMemo(() => {
    return clubsList?.data?.value?.rows?.map((element) => ({
      ...element,
      dateOpen: element.dateOpen
        ? dayjs(element?.dateOpen).format("DD.MM.YYYY")
        : "",
    }));
  }, [clubsList]);

  return (
    <>
      <AddEditClubModal
        visible={isOpenAddEditModal}
        setVisible={setIsOpenAddEditModal}
        //clubInfo={clubInfo}
        clubId={clubInfo?.id}
        clubInfo={globalCurrentClub?.data.value}
        setPage={setPage}
        setPageSize={setPageSize}
        mnemo={mnemo}
      />
      <SureModal
        visible={isOpenDeleteModal}
        setVisible={setIsOpenDeleteModal}
        onClickYes={onClickDelete}
      />
      <NumberChangesShowModal
        visible={isOpenNumbersModal}
        setVisible={setIsOpenNumbersModal}
        //clubInfo={clubInfo}
        clubId={clubInfo?.id}
        clubInfo={globalCurrentClub?.data.value}
        setPage={setPage}
        setPageSize={setPageSize}
      />
      {window.innerWidth >= 768 ? (
        <AdminTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onChange={handleTableChange}
          loading={clubsListLoading}
          onClickRowOne={(record) => {
            setClubInfo(record);
            dispatch(getClubById(record.id));
          }}
          columns={clubsList}
          rows={formatedClubsRows}
          total={clubsList?.data?.value?.totalCount}
          title={() => (
            <TableTitle
              isDeleted={isDeleted}
              showDeletedItems={showDeletedItems}
              onClickOpenModal={() => {
                setIsOpenAddEditModal({
                  open: true,
                  flag: "add",
                });
              }}
              mnemoButton={
                !mnemo?.children?.find((el) => el.mnemo === "insertBtn")
              }
              mnemoSwitcher={
                !mnemo?.children?.find((el) => el.mnemo === "isDeletedBtn")
              }
            />
          )}
          items={items}
          isDeleted={isDeleted}
        />
      ) : (
        <AntdMobileTable
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          elementsList={clubsList}
          elementsListLoading={clubsListLoading}
          setIsOpenAddEditModal={setIsOpenAddEditModal}
          setIsOpenDeleteModal={setIsOpenDeleteModal}
          onChange={handleTableChange}
          items={items}
          filterOptionsArr={filterOptionsArr}
          clickOnAction={clickOnAction}
          handlePaginationChange={handlePaginationChange}
          searchInput={searchInput}
          onClickSearchItem={onClickSearchItem}
        />
      )}
    </>
  );
};

export default Clubs;
